import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInPath } from 'common/config/urls';
import { SIGN_IN_VIEW } from 'common/constants/auth';
import { useLogOutUser } from 'pages/Auth/hooks';
import { buildSignInUrl, subscribeToAuthSessionSync, syncAuthTokensWithRememberPreference } from 'pages/Auth/utils';

const AuthSessionBridge = () => {
  const navigate = useNavigate();
  const logOutRemoteUser = useLogOutUser({
    broadcastSessionLogout: false,
    noRedirect: true,
  });

  // Keep persisted auth tokens aligned before cross-tab session listeners start.
  useEffect(() => {
    syncAuthTokensWithRememberPreference();
  }, []);

  // Subscribe once per route instance so logout in another tab closes this session too.
  useEffect(() => {
    const unsubscribe = subscribeToAuthSessionSync({
      onRemoteLogout: () => {
        logOutRemoteUser();

        if (window.location.pathname === signInPath) {
          return;
        }

        navigate(buildSignInUrl({ view: SIGN_IN_VIEW.IDENTIFIER }), { replace: true });
      },
    });

    return () => {
      unsubscribe();
    };
  }, [logOutRemoteUser, navigate]);

  return null;
};

export default AuthSessionBridge;
